import {
    AI_CHECK_WALLET_ERROR,
    AI_CHECK_WALLET_ERROR_SETTED,
    AI_CHECK_WALLET_PROCESSING,
    AI_CHECK_WALLET_PROCESSING_SETTED,
    AI_CHECK_WALLET_WELCOME,
    AI_CHECK_WALLET_WELCOME_SETTED,
    AI_FIRST_WELCOME,
    AI_FIRST_WELCOME_SETTED,
    AI_NEW_TEXT_SETTED,
    AI_NEW_TEXT_UNSETTED,
    AI_TOKEN_ANALYZER_PROCESSING,
    AI_TOKEN_ANALYZER_PROCESSING_SETTED,
    AI_TOKEN_ANALYZER_WELCOME,
    AI_TOKEN_ANALYZER_WELCOME_SETTED
} from "../consts/consts";

const initialState = {
    status: AI_FIRST_WELCOME,
    text: "Hello, I'm AI bot!¦You can explore\nblockchains with me¦Good luck)",
    pauseDelay: 5,
    phrasesDelay: 10,
    isNewText: true
};

const setCheckWalletWelcome = () => {
    return {
        status: AI_CHECK_WALLET_WELCOME,
        text: "Enter the wallet address and click search",
        pauseDelay: 5,
        phrasesDelay: 10,
        isNewText: true
    }
};

const setCheckWalletError = () => {
    return {
        status: AI_CHECK_WALLET_ERROR,
        text: "Error¦Try again",
        pauseDelay: 5,
        phrasesDelay: 10,
        isNewText: true
    }
};

const setCheckWalletProcessing = () => {
    return {
        status: AI_CHECK_WALLET_PROCESSING,
        text: "Processing transactions...",
        pauseDelay: 5,
        phrasesDelay: 10,
        isNewText: true
    }
};

const setTokenAnalyzerProcessing = () => {
    return {
        status: AI_TOKEN_ANALYZER_PROCESSING,
        text: "Processing transactions...",
        pauseDelay: 5,
        phrasesDelay: 10,
        isNewText: true
    }
};

const setTokenAnalyzerWelcome = () => {
    return {
        status: AI_TOKEN_ANALYZER_WELCOME,
        text: "Enter the token address and click search",
        pauseDelay: 5,
        phrasesDelay: 10,
        isNewText: true
    }
};

const setNewAiCircleText = (aiCircle) => {
    return {
        status: aiCircle.status,
        text: aiCircle.text,
        pauseDelay: aiCircle.pauseDelay,
        phrasesDelay: aiCircle.phrasesDelay,
        isNewText: true
    }
};

const unsetNewAiCircleText = (aiCircle) => {
    return {
        status: aiCircle.status,
        text: aiCircle.text,
        pauseDelay: aiCircle.pauseDelay,
        phrasesDelay: aiCircle.phrasesDelay,
        isNewText: false
    }
};
const updateAiCircle = (state, action) => {

    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case AI_FIRST_WELCOME_SETTED:
            return initialState;
        case AI_CHECK_WALLET_WELCOME_SETTED:
            return setCheckWalletWelcome();
        case AI_TOKEN_ANALYZER_WELCOME_SETTED:
            return setTokenAnalyzerWelcome();
        case AI_CHECK_WALLET_ERROR_SETTED:
            return setCheckWalletError();
        case AI_CHECK_WALLET_PROCESSING_SETTED:
            return setCheckWalletProcessing();
        case AI_TOKEN_ANALYZER_PROCESSING_SETTED:
            return setTokenAnalyzerProcessing();
        case AI_NEW_TEXT_SETTED:
            return setNewAiCircleText(state.aiCircle);
        case AI_NEW_TEXT_UNSETTED:
            return unsetNewAiCircleText(state.aiCircle);
        default:
            return state.aiCircle;
    }
};

export {
    updateAiCircle
}